<template>
  <button class="ab-button" :class="abStyleName"
          @click.stop="$emit('admin-button', abName)"
          :disabled="abDisabled">
    {{abValue | translate}}
  </button>
</template>

<script>
export default {
  name: 'AdminButton',
  props: [
    'abValue',
    'abStyleName',
    'abName',
    'abDisabled',
  ],
};
</script>

<style lang="scss" scoped>
  .ab-button:disabled {
    cursor: not-allowed;
    opacity: .6;
  }
</style>
